import React from 'react'
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormTitle from '../../../../library/form/components/FormTitle'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormHHMMInput from '../../../../library/form/components/FormHHMMInput';
import { UiGridColOne, UiCol } from "../../../../library/layout/Index";

const BomProcessEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '400px', overflowY: 'scroll' }}
            formStyle={{ width: '550px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} value="Add Process" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pCategory" }} value="Process" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", paramName: "pCategory",
                                acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' },
                                actionId: "refresh", actionParam: {editSource:"pCategory"}
                            }}
                            />
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ 
                                    InputType: "ac", paramName: "pName", acMethod: "ProcessName", acDepCtrl: { catId: '#pCategory', dtId: "%dataList.valLDT" },
                                    actionId: "refresh", actionParam: {editSource:"pName"}
                                }} 
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "seqNo" }} value="Sequence" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "seqNo" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "seqNo" }} value="Is Outsoruced" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isOutsource" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "estQty1" }} value="Process Time" />
                            </span>
                            <FormHHMMInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "estQty1" }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className='uiSpacerH10' />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processCost" }} value="Process Cost" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "processCost" }} />
                            <span> /</span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className='uiSpacerH10' />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ohCost" }} value="OH Cost" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "ohCost" }} />
                            <span> /</span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className='uiSpacerH10' />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Details" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" className="uiFrmText" rows="3" cols="82" action={{ paramName: "comment" }} />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(BomProcessEditor, "bomProcess", "bomProcess,bomHeader")